import * as React from 'react';
import type { SVGProps } from 'react';
const SvgOurPartnersTrustUs = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 80 80"
    {...props}
  >
    <rect width={80} height={80} fill="#1E6CE1" rx={40} />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="m40 46-6-6m6 6a44.7 44.7 0 0 0 8-4m-8 4v10s6.06-1.1 8-4c2.16-3.24 0-10 0-10m-14-2a44 44 0 0 1 4-7.9A25.76 25.76 0 0 1 60 20c0 5.44-1.56 15-12 22m-14-2H24s1.1-6.06 4-8c3.24-2.16 10 0 10 0M25 49c-3 2.52-4 10-4 10s7.48-1 10-4c1.42-1.68 1.4-4.26-.18-5.82A4.36 4.36 0 0 0 25 49"
    />
  </svg>
);
export default SvgOurPartnersTrustUs;
